import React from 'react';
import { useShippingSimulator } from '../hooks/useShippingSimulator';

const Button = () => {
	const { toggleOpen } = useShippingSimulator();
	return (
		<button
			onClick={toggleOpen}
			className="
      vtex-button
      bw1
      ba
      fw5
      v-mid
      relative
      pa0
      lh-solid
      br2
      min-h-small
      t-action--small
      bg-disabled
      b--muted-5
      c-on-disabled
      w-100
    "
			type="submit"
			data-dashlane-rid="b1d4414dab595acf"
			data-dashlane-label="true"
			data-form-type="other"
		>
			<div
				className="
        vtex-button__label
        flex
        items-center
        justify-center
        h-100
        ph5
        w-100
        border-box
      "
				style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
			>
				Calcular o frete
			</div>
		</button>
	);
};

export default Button;
